export default "__VITE_ASSET__DMbsFWeB__"